import { Fragment, useRef, useState } from 'react';

const Checkbox = ({
  id,
  name,
  label,
  value = '',
  inputRef = useRef(null),
  checkedByDefault = false,
  hasErrors,
  labelPos = 'after',
  labelSize = 1,
  changeCallback = () => {},
}) => {
  const [isChecked, setIsChecked] = useState(checkedByDefault);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e) => {
    setIsChecked(!isChecked);
    changeCallback(e);
  };

  const handleFocus = (e) => {
    if(e.target === inputRef.current) {
      setIsFocused(true);
    } else {
      setIsFocused(false)
    }
  }

  const renderLabel = () => {
    let link = false;

    if( label.indexOf("[[") !== -1 ) {
      link = label.substring(
        label.indexOf("[[") + 2, 
        label.lastIndexOf("]]")
      );
    }

    label = label.replace(link,'');
    label = label.replace('[[]]','');
    
    if ( link ) {
      let anchor = link.split('=');
      let href = anchor[0];
      let anchorText = anchor[1];
      return <Fragment>{label} <a className="button button--alt button--tiny" href={href} target="_blank" rel="noreferrer" style={{margin: 0}}>{anchorText}</a> </Fragment>
    } else {
      return label
    }
  }

  return (
    <div
      className={`gl-checkbox ${isChecked ? 'gl-checkbox--isChecked' : ''} ${
        hasErrors ? 'gl-checkbox--errors' : ''
      }`}
    >
      <label style={{fontSize : labelSize + 'rem'}}>
        {labelPos === 'before' && <span className="label">{renderLabel()}</span>}
        <span className={`checkbox-container ${isFocused ? 'focused' : ''}`}>
          <svg
            className="checkbox"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            {isChecked && (
              <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
            )}
            {!isChecked && (
              <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
            )}
          </svg>
          <input
            type="checkbox"
            name={name}
            id={id}
            ref={inputRef}
            checked={isChecked}
            value={value}
            onChange={handleChange}
            onFocus={(e) => {handleFocus(e)}}
            onBlur={() => {setIsFocused(false)}}
          />
          <span className="ripple"></span>
        </span>
        {labelPos === 'after' && <span className="label">{renderLabel()}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
